import { css, cx } from 'emotion';
import {
	desktopMaxWidthBreakpoint,
	mobileMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	headingXLarge,
	headingSmallLight,
} from 'inside-out/global-styles';

export const headerStyle = background =>
	css({
		background: background,
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			backgroundImage: 'none',
		},
	});

export const headerInnerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	margin: '0 auto',
});

export const headerTextWrapperStyle = hasIcon => {
	let baseObj = {
		padding: '60px 0',
		display: 'table',
		width: '100%',
		'& > *': {
			display: 'table-cell',
			verticalAlign: 'top',
			lineHeight: '1',
		},
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			padding: '30px 0',
		},
	};
	if (hasIcon) {
		baseObj['marginLeft'] = '-68px';
		baseObj['& > div:first-child'] = {
			width: '68px',
		};
	}
	return css(baseObj);
};

export const titleStyle = titleColour =>
	cx(
		headingXLarge,
		css({
			padding: '0 20px',
			color: titleColour,
		})
	);

export const subTitleStyle = subTitleTextColor =>
	cx(
		headingSmallLight,
		css({
			maxWidth: '760px',
			marginTop: '17px',
			marginBottom: '0',
			padding: '0 20px',
			color: subTitleTextColor,
		})
	);



// WEBPACK FOOTER //
// ./src/components/shared/pageHeader/styles.js